import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { EmployeesGraphicIcon } from '../../../../lib/icons';
import { useTranslation } from 'react-i18next';
import { useCreateCustomBenefit } from '../hooks/useCreateCustomBenefit';
import { useStore } from '../../../../hooks/useStore';
import { Button } from '../../../../lib/components/atomic/button';

export const BenefitConclusion = observer(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { newCustomBenefit } = useCreateCustomBenefit();
  const { companyStore } = useStore();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
    >
      <EmployeesGraphicIcon height={150} width={150} />
      <Typography
        variant="subtitle1"
        fontSize="1.5rem"
        color="primary.main"
        marginTop="3rem"
        marginBottom="1rem"
      >
        {newCustomBenefit.editingBenefitId ? t('custom:edit_saved') : t('custom:active_created')}
      </Typography>

      <Button
        onClick={async () => {
          await companyStore.fetchCustomBenefitSettings();
          newCustomBenefit.clear();
          navigate('/benefits/custom');
        }}
        className="mt-4"
      >
        {t('custom:to_overview')}
      </Button>
    </Box>
  );
});
